import React from 'react';
import { GenericTable } from './generic-table';

export const Table = ({ tableInstance, isLoading, isError, emptyMessage, dataIntercomTarget }) => {
  return (
    <GenericTable
      tableInstance={tableInstance}
      isLoading={isLoading}
      isError={isError}
      emptyMessage={emptyMessage}
      dataIntercomTarget={dataIntercomTarget}
    />
  );
};
